var map = {
	"./client-1.png": 5172,
	"./client-2.png": 447,
	"./client-3.png": 6646,
	"./client-4.png": 6617,
	"./client-5.png": 2416,
	"./client-6.png": 9979,
	"./client-7.png": 8434,
	"./gallery-1.png": 4051,
	"./gallery-2.png": 9560,
	"./gallery-3.png": 7825,
	"./gallery-4.png": 1710,
	"./gallery-5.png": 4727,
	"./gallery-6.png": 4092,
	"./logo.png": 2806,
	"./machine-1.png": 3842,
	"./machine-2.png": 7849,
	"./machine-3.png": 2096,
	"./machine-4.png": 7967,
	"./sample-book-1.png": 5765,
	"./sample-book-2.png": 8414,
	"./sample-book-3.png": 6727,
	"./sample-landing.png": 2439,
	"./sample-magazine-1.png": 4768,
	"./sample-magazine-2.png": 171,
	"./sample-magazine-3.png": 6514,
	"./sample-poster-1.png": 6857,
	"./sample-poster-2.png": 274,
	"./sample1.png": 5760,
	"./sample2.png": 4443,
	"./sample3.png": 5442,
	"./testimonial-1.png": 5532,
	"./testimonial-2.png": 7287,
	"./testimonial-3.png": 8062,
	"./testimonial-4.png": 5777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;